import React = require('react');
import Ajax from '../../lib/Ajax';

interface IInvitateResponseBoxProps {
    eventId:number
    status:string
}

interface IInvitateResponseBoxState {
    status:string
}

export default class InvitateResponseBox extends React.Component<IInvitateResponseBoxProps, IInvitateResponseBoxState>{

    constructor(props:IInvitateResponseBoxProps){
        super(props);
        this.state= {
            status: this.props.status
        };
    }

    private InvitateClickHandler(evt, status): void {
        evt.preventDefault();
        // tslint:disable-next-line:no-unused-expression
        new Ajax('/event/inviteToggle', 'POST', {
            id: this.props.eventId,
            status: status
        }, (ret)=>{
            if ( ret.success !== undefined ) {
                if ( ret.remove !== undefined) {
                    status = '';
                }
                this.setState({
                     status: status
                });

            }
        });
    }


    render() {
        return (
            <div className="invitate_response_box">
                <ul>
                    <li className={ this.state.status==='yes'?'active':''}>
                        <a onClick={ e => this.InvitateClickHandler(e, 'yes') }>Ott leszek</a>
                    </li>
                    <li className={ this.state.status==='dont_now'?'active':''}>
                        <a onClick={ e => this.InvitateClickHandler(e, 'dont_now') }>Nem tudom</a>
                    </li>
                    <li className={ this.state.status==='no'?'active':''}>
                        <a onClick={ e => this.InvitateClickHandler(e, 'no') }>Nem tudok elmenni</a>
                    </li>
                </ul>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/event/InvitateResponseBox.tsx